/*
 * 
 * key
 * 
 */
const key = 'RW1wbG95ZWVSZXF1ZXN0'

export default key